export const categories = [
  {
    slug: 'fashion',
    name: '欧美时尚',
    icon: 'ri-t-shirt-line',
    description: '探索欧美前沿时尚潮流，精选搭配灵感与设计师品牌故事',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20European%20fashion%20runway%20scene%20with%20models%20in%20designer%20clothing%2C%20soft%20natural%20lighting%2C%20minimalist%20white%20studio%20background%2C%20editorial%20fashion%20photography%20style%2C%20clean%20aesthetic%20with%20warm%20neutral%20tones&width=800&height=600&seq=cat-fashion-01&orientation=landscape',
    count: 128,
  },
  {
    slug: 'music',
    name: '欧美音乐',
    icon: 'ri-music-line',
    description: '聆听欧美最新热门单曲，深度解读经典专辑与音乐人故事',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20vinyl%20record%20player%20on%20warm%20wooden%20table%2C%20soft%20ambient%20lighting%2C%20cozy%20atmosphere%20with%20records%20scattered%20artfully%2C%20warm%20golden%20hour%20glow%2C%20nostalgic%20music%20studio%20aesthetic&width=800&height=600&seq=cat-music-01&orientation=landscape',
    count: 96,
  },
  {
    slug: 'film',
    name: '欧美影视',
    icon: 'ri-movie-line',
    description: '追踪欧美热门影视剧集，专业影评与幕后深度解析',
    image: 'https://readdy.ai/api/search-image?query=Classic%20movie%20theater%20interior%20with%20red%20velvet%20curtains%20and%20golden%20accents%2C%20warm%20cinematic%20lighting%2C%20vintage%20Hollywood%20glamour%20aesthetic%2C%20elegant%20composition%20with%20dramatic%20shadows&width=800&height=600&seq=cat-film-01&orientation=landscape',
    count: 85,
  },
  {
    slug: 'brand',
    name: '欧美品牌',
    icon: 'ri-store-2-line',
    description: '深度了解欧美知名品牌故事，精选好物推荐与品牌测评',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20boutique%20storefront%20with%20elegant%20window%20display%2C%20warm%20golden%20lighting%2C%20sophisticated%20European%20shopping%20street%20scene%2C%20refined%20retail%20atmosphere%20with%20timeless%20architecture&width=800&height=600&seq=cat-brand-01&orientation=landscape',
    count: 72,
  },
  {
    slug: 'culture',
    name: '欧美文化',
    icon: 'ri-global-line',
    description: '深入欧美文化内核，探索艺术、文学、历史与社会思潮',
    image: 'https://readdy.ai/api/search-image?query=European%20art%20museum%20gallery%20with%20classical%20paintings%20and%20sculptures%2C%20warm%20ambient%20lighting%2C%20marble%20floors%2C%20elegant%20cultural%20atmosphere%2C%20sophisticated%20interior%20with%20ornate%20gold%20frames&width=800&height=600&seq=cat-culture-01&orientation=landscape',
    count: 64,
  },
  {
    slug: 'lifestyle',
    name: '欧美生活',
    icon: 'ri-cup-line',
    description: '体验欧美品质生活方式，从美食旅行到家居设计的灵感分享',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20European%20cafe%20interior%20with%20warm%20sunlight%20streaming%20through%20windows%2C%20wooden%20furniture%2C%20fresh%20pastries%20on%20marble%20counter%2C%20relaxed%20lifestyle%20atmosphere%2C%20soft%20cream%20and%20beige%20tones&width=800&height=600&seq=cat-lifestyle-01&orientation=landscape',
    count: 91,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};